/**
 * Instruction provider.
 *
 * Owns one instruction store for its subtree, created once via `useState` lazy
 * init so the reference is stable for the provider's lifetime. Because the
 * store identity never changes, registering a block updates store state without
 * re-rendering the provider or any sibling instruction block.
 */

import type { ReactNode } from 'react';
import { useState } from 'react';

import { InstructionStoreContext } from '#plugin-chat/contexts/InstructionStoreContext.ts';
import { createInstructionStore } from '#plugin-chat/lib/instructions/instructionStore.ts';

export function InstructionProvider({ children }: { children: ReactNode }) {
  const [store] = useState(() => createInstructionStore());
  return <InstructionStoreContext value={store}>{children}</InstructionStoreContext>;
}
